import create, { UseStore } from 'zustand';
import { WorksheetId } from './domain';
import { log } from './log';
import { Request, RequestProps } from './';
import { WorksheetResult } from './worksheet-service';
import { config } from './config';
import { getToken } from './auth/proxy-fetch';

const endpoint = () => config.socketUrl;

export type SocketApi = Request<WorksheetResult> & {
  close(): void;
  connect(): void;
};

export interface SocketProps extends Partial<RequestProps<WorksheetId, any>> {
  worksheetId: string;
  deferConnection?: boolean;
}

export type Messages = UseStore<SocketApi>;
export function socketRequest(props?: SocketProps): Messages {
  const { onSuccess, onError, worksheetId, deferConnection } = { ...props };

  let socket: WebSocket;

  let localClose = false;
  const close = () => {
    if (socket) {
      localClose = true;
      socket.close();
    }
  };

  const api: any = create((set) => ({
    loading: false,
    data: null,
    error: null,
    close,
    fetch: async (args: WorksheetId) => {
      set({ loading: true, error: null });

      const { worksheetId } = args;

      async function connect() {
        const authorizer = await getToken();
        const url = `${endpoint()}?channelTarget=worksheet&worksheetId=${worksheetId}&authorizer=${authorizer}`;

        socket = new WebSocket(url);

        socket.onopen = (event: Event) => {
          set({ loading: false, error: null, data: event });
          log.info('Socket is open', worksheetId);
          console.info('Socket is open', worksheetId);

          localClose = false;
          return Promise.resolve(event);
        };

        socket.onmessage = (event: MessageEvent) => {
          // log.info('socket message', event);

          let data: WorksheetResult = null;
          if (event.data) {
            try {
              data = JSON.parse(event.data);
            } catch (error) {
              set({ loading: false, error });
              if (onError) {
                onError(error);
              }
            }
          }

          if (data) {
            //   console.log('socket data', data)
            set({ loading: false, error: null, data });
            if (onSuccess) {
              onSuccess(data);
            }
          }
          return Promise.resolve(event);
        };

        socket.onclose = (event: CloseEvent) => {
          set({ loading: false, error: null });

          log.info('Socket is closed', worksheetId);

          if (!localClose) {
            console.info('Socket is closed by the network', worksheetId);

            setTimeout(() => {
              connect();
            }, 500);

          } else {
            log.info('Socket is closed', worksheetId);
            console.info('Socket is closed for transition', worksheetId);

          }

          return Promise.resolve(event);
        };

        socket.onerror = (error: Event) => {
          log.info('socket error', error);
          console.info('Socket error', worksheetId, error);

          if (onError) {
            onError(error);
          }
          set({ loading: false, error });
          return Promise.resolve(error);
        };
      }
      return connect();
    },
    connect: () => api.getState().fetch({ worksheetId }),
  }));

  if (worksheetId && !deferConnection) {
    api.getState().connect();
  }

  return api as Messages;
}
